import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function FinalCTA() {
  const {
    t
  } = useLanguage();
  const benefits = [t('final.benefit1'), t('final.benefit2'), t('final.benefit3')];
  return <section className="bg-brand-navy py-20 md:py-28 text-white relative overflow-hidden" data-id="element-28">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-29">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-brand-primary rounded-full opacity-20 blur-3xl" data-id="element-30"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-brand-accent rounded-full opacity-10 blur-3xl" data-id="element-31"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-32">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-33">
          <h2 className="text-4xl md:text-5xl font-extrabold mb-6 leading-tight" data-id="element-34">
            {t('final.title')}
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 mb-10 font-medium" data-id="element-35">
            {t('final.subtitle')}
          </p>

          <div className="flex flex-col items-center space-y-4 mb-12" data-id="element-36">
            {benefits.map((benefit, index) => <motion.div key={index} className="flex items-center space-x-3 text-lg md:text-xl" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.3 + index * 0.1
          }} data-id="element-37">
                <CheckCircle2 className="w-6 h-6 text-brand-accent flex-shrink-0" data-id="element-38" />
                <span data-id="element-39">{benefit}</span>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} className="flex flex-col items-center" data-id="element-40">
            <a href="https://wa.me/15514017684?text=Hola,%20quiero%20una%20consulta%20gratuita%20para%20hacer%20crecer%20mi%20negocio%20en%20NJ" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-brand-accent text-brand-navy font-extrabold text-xl md:text-2xl py-5 px-10 rounded-xl shadow-2xl hover:bg-yellow-300 hover:scale-105 transition-all duration-300 flex items-center justify-center min-h-[72px]" data-id="element-41">
              {t('final.cta')}
            </a>
            <p className="text-gray-400 mt-4 text-sm md:text-base font-medium" data-id="element-42">
              {t('final.subtext')}
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}